<script>
  import {onMount} from 'svelte';
  import {navigateTo} from 'svelte-router-spa';
  import {form, bindClass} from 'svelte-forms';
  import axios from 'axios';
  import passwordValidator from 'password-validator';
  import FilePond, {registerPlugin} from 'svelte-filepond';
  import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  import {authToken} from '../../store/auth';
  import {showErrorMessage, showSuccessMessage} from '../../utils/toast';
  import {Navigate} from 'svelte-router-spa';
  import initPhoneValidator from '../../utils/phone-number';
  import 'intl-tel-input/build/css/intlTelInput.css';
  import {userMobileCountryCode} from '../../store/auth';
  import {parseAndShowErrorMessage} from '../../utils/errorParser';

  registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview
  );

  const passwordValidatorSchema = new passwordValidator();
  passwordValidatorSchema.is().min(8).is().max(50).has().not().spaces();

  let baseApiURl = morrDashboard.env.API_URL;
  let email = '';
  let mobileNumber = '';
  let agreePrivacyPolicy = false;
  let country_code = '60';
  let mobile_otp = '';
  let email_otp = '';
  let validationError = null;
  let mobileNumberRef;
  let mobileNumberInstance;
  let isValidMobileNumber = true;

  const signUpForm = form(
    () => ({
      email: {value: email, validators: ['required', 'email']},
      agreePrivacyPolicy: {
        value: agreePrivacyPolicy,
        validators: ['required']
      },
      mobileNumber: {
        value: mobileNumber,
        validators: ['required']
      },
      mobileOTP: {
        value: mobile_otp,
        validators: ['required']
      },
      emailOTP: {
        value: email_otp,
        validators: ['required']
      },
    }),
    {
      initCheck: false,
      validateOnChange: true
    }
  );

  function performSignUp() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(`${morrDashboard.env.GOOGLE_RECAPTCHA_SITE_KEY}`, {
          action: 'login'
        })
        .then(function (token) {
          if (token) {
            requestSignUpApi(token);
            increaseTime();
          }
        });
    });
  }

  function requestSignUpApi(captcha) {
    if (!email) {
      showErrorMessage('Enter Email!');
    } else if (!mobileNumber) {
      showErrorMessage('Enter Mobile Number!');
    } else {
      let payload = {
        email: email.trim(),
        country_code: country_code,
        mobile: mobileNumber.trim(),
      };
      axios
        .post(
          `${morrDashboard.env.API_V2_URL}/users/manager/onboarding`,
          payload,
          {
            headers: {
              // 'x-google-token': captcha
            }
          }
        )
        .then(res => {
          showSuccessMessage(
            'Account successfully created, Please verify Email and Mobile Number'
          );
          performNext();
        })
        .catch(err => {
          parseAndShowErrorMessage(err);
          console.log('request failed', err.response);
        });
    }
  }

  function performNext() {
    let requiredFields = ''
    if (!email){
      requiredFields = 'Email'
    }

    if (!country_code){
      requiredFields = requiredFields + ', Country Code'
    }
    if (!mobileNumber){
      requiredFields = requiredFields + ', Mobile '
    }

    if (requiredFields) {
      showErrorMessage(`Please Enter ${requiredFields.replace(/(^,)|(,$)/g, "")}`);
    } else {
      increaseFormValue();
      initializeMobileNumberHandler();
    }
  }

  function performVerification() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(`${morrDashboard.env.GOOGLE_RECAPTCHA_SITE_KEY}`, {
          action: 'login'
        })
        .then(function (token) {
          if (token) {
            requestVerificationApi(token);
          }
        });
    });
  }

  function requestVerificationApi(captcha) {
    if (!mobile_otp) {
      showErrorMessage('Enter Mobile OTP');
    } else if (!email_otp) {
      showErrorMessage('Enter Email OTP');
    } else if (!agreePrivacyPolicy) {
      showErrorMessage('Agree the Privacy Policy');
    } else {
      let payload = {
        email: email.trim(),
        mobile: mobileNumber.trim(),
        country_code: country_code,
        email_otp: email_otp,
        sms_otp: mobile_otp
      };

      axios
        .post(
          `${morrDashboard.env.API_URL}/users/manager/onboarding/verification`,
          payload,
          {
            headers: {
              'x-google-token': captcha
            }
          }
        )
        .then(res => {
          showSuccessMessage(
            'Successfully verified details. You can login now'
          );
          navigateTo('/auth/login');
        })
        .catch(err => {
          console.log('Verification Error', err.response);
          parseAndShowErrorMessage(err);
        });
    }
  }

  function performResend() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(`${morrDashboard.env.GOOGLE_RECAPTCHA_SITE_KEY}`, {
          action: 'login'
        })
        .then(function (token) {
          if (token) {
            requestVerificationResendApi(token);
            increaseTime();
          }
        });
    });
  }

  function requestVerificationResendApi(captcha) {
    let payload = {
      email: email.trim(),
      mobile: mobileNumber.trim(),
      country_code: country_code,
      email_otp: email_otp ? email_otp : 0,
      sms_otp: mobile_otp ? mobile_otp : 0
    };

    axios
      .post(
        `${morrDashboard.env.API_URL}/users/manager/onboarding/resend`,
        payload,
        {
          headers: {
            'x-google-token': captcha
          }
        }
      )
      .then(res => {
        showSuccessMessage('Successfully re-sent OTPs');
      })
      .catch(err => {
        console.log('Verification Error', err.response);
        parseAndShowErrorMessage(err);
      });
  }

  let disabled;
  $: disabled = true;

  let time;
  $: time = 1;

  let timerID;

  let disableTime;
  $: disableTime = 1;

  function timeCount() {
    timerID = setInterval(() => {
      if (time <= 0) {
        disabled = false;
        clearInterval(timerID);
        return;
      }
      time--;
    }, 1000);
  }

  function increaseTime() {
    disabled = true;
    time = disableTime * 60;
    disableTime++;
    timeCount();
  }

  let formValue;
  $: formValue = 1;
  function increaseFormValue() {
    formValue++;
  }

  function initializeMobileNumberHandler() {
    setTimeout(() => {
      mobileNumberInstance = initPhoneValidator(
        mobileNumberRef,
        $userMobileCountryCode
      );
    }, 500);
  }

  onMount(() =>{
    initializeMobileNumberHandler();
  })
</script>

<div class="main-container">
  <div
    class="forms-container w-11/12 sm:10/12 md:w-9/12 lg:w-7/12 xl:w-6/12 shadow-lg rounded-xl"
  >
    <div
      class="p-row w-full justify-evenly items-center border-b-2 border-gray h-14 shadow-sm"
    >
      <div
        class="text-sm text-center font-semibold w-1/2 h-full py-4"
        class:active={formValue === 1 ||formValue === 2}
      >
        Contact Information
      </div>
      <div
        class="text-sm text-center font-semibold w-1/2 h-full py-4"
        class:active={formValue === 2}
      >
        Verification
      </div>
    </div>
    
    {#if formValue === 1}
      <div class="form w-full">
        <h1 class="text-center font-bold text-xl my-4">Credentials</h1>
        <div class="flex flex-col w-11/12 justify-center leading-relaxed">
          <div class="column-1 w-full leading-10 registration">
            
            <div class="w-10/12 relative z-2 my-4">
              <input
                class="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black border-gray-200"
                type="tel"
                placeholder=" "
                bind:value={mobileNumber}
                bind:this={mobileNumberRef}
                on:input={() => {
                  isValidMobileNumber = mobileNumberInstance.isValidNumber();
                }}
                on:change={() => {
                  country_code =
                    mobileNumberInstance.getSelectedCountryData().dialCode;
                    mobileNumberInstance.setNumber(mobileNumberInstance.getNumber());
                }}
              />
              {#if !isValidMobileNumber && mobileNumber.length > 0}
                <div class="absolute right-0 duration-300 top-6 -z-1 origin-0 text-gray-500 text-sm text-red-500">
                  <span><i class="fas fa-times-circle"></i></span>
                </div>
              {:else if isValidMobileNumber && mobileNumber.length > 0}
                <div class="absolute right-0 duration-300 top-6 -z-1 origin-0 text-gray-500 text-sm text-green-500">
                  <span><i class="fas fa-check-circle"></i></span>
                </div>
               {/if}

              <label
                  for="mobileNumber"
                  class="absolute duration-300 top-3 -z-1 origin-0 text-gray-500 text-sm"
                >
                <span>Mobile Number</span>
              </label>
            </div>

            <input
              class="w-10/12 my-2"
              type="hidden"
              placeholder="Country Code"
              bind:value={country_code}
            />
            
            <div class="w-10/12 relative z-0 my-4">
              <input
                class="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black border-gray-200"
                type="text"
                placeholder=" "
                bind:value={email}
                use:bindClass={{
                  form: signUpForm,
                  invalid:
                    'text-sm sm:text-base relative w-full border rounded placeholder-gray-400 focus:border-indigo-400 focus:outline-none py-2 pr-2 pl-12 border-red-500'
                }}
              />
              <label
                  for="email"
                  class="absolute duration-300 top-3 -z-1 origin-0 text-gray-500 text-sm"
                >
                <span>Email</span>
              </label>
            </div>

          </div>
        </div>
        <div class="text-center w-full my-4">
          <button
            class="btn w-10/12 morr-background rounded-3xl uppercase py-0 h-10 font-bold outline-none"
            on:click|preventDefault={performSignUp}>Next</button
          >
        </div>
      </div>
    {:else if formValue === 2}
      <div class="form w-full">
        <h1 class="text-center font-bold text-xl my-4">Verification</h1>
        <div class="flex flex-col w-full">
          <div class="column-1 w-full leading-10">
            <div class="w-10/12 relative z-0 my-4">
              <input
                class="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black border-gray-200"
                type="text"
                placeholder=" "
                bind:value={mobile_otp}
              />
              <label
                  for="mobile_otp"
                  class="absolute duration-300 top-3 -z-1 origin-0 text-gray-500 text-sm"
                >
                <span>Mobile OTP</span>
              </label>
            </div>
            <div class="w-10/12 relative z-0 my-4">
              <input
                class="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-black border-gray-200"
                type="text"
                placeholder=" "
                bind:value={email_otp}
              />
              <label
                  for="email_otp"
                  class="absolute duration-300 top-3 -z-1 origin-0 text-gray-500 text-sm"
                >
                <span>Email OTP</span>
              </label>
            </div>

            <div class="form-group text-left mt-2">
              <input
                type="checkbox"
                id="agreePolicy"
                bind:checked={agreePrivacyPolicy}
              />
              <label for="agreePolicy"
                >I agree with the
                <a
                  href="https://morr.my/privacy-policy"
                  target="_blank"
                  no-follow
                  class="text-red-500"
                >
                  Privacy Policy
                </a></label
              >
            </div>
          </div>
        </div>
        <div class="text-center w-full my-4 flex-col justify-evenly">
          <button
            class="w-5/12 morr-background rounded-3xl uppercase py-0 h-10 font-bold outline-none"
            on:click|preventDefault={performVerification}>Register</button
          >
          <button
            class={`w-5/12 morr-background-light border-2 rounded-3xl border-opacity-10 border-yellow-600 py-0 h-10 font-bold outline-none ${
              time !== 0 ? 'opacity-40' : 'opacity-100'
            }`}
            {disabled}
            on:click|preventDefault={performResend}
          >
            {#if time !== 0}
              {`Resend in ${time}`}
            {:else}
              {`Resend OTPs`}
            {/if}
          </button>
        </div>
      </div>
    {/if}
    <div
      class="flex relative my-4 w-full z-2 justify-between px-24 pb-4 text-lg font-normal text-black"
    >
      <div class="space-x-2 inline-block">
        <Navigate to="/auth/forgot-password">
          <small>forgot password?</small>
        </Navigate>
      </div>

      <div class="space-x-2 inline-block">
        <Navigate to="/auth/login">
          <small>already have an account?</small>
        </Navigate>
      </div>
    </div>
  </div>
</div>

<style>
  :global(.registration .iti) {
    border-bottom: 1px solid #b3b1b140;
  }
  :global(.registration .iti--separate-dial-code .iti__selected-flag) {
    background-color: transparent !important;
  }
  :global(.registration .iti__country-list) {
    max-height: 300px !important;
    z-index: 9 !important;
  }

  :global(.registration .intl-tel-input .flag-container) {
    position: static;
  }

  :global(.registration .intl-tel-input .selected-flag) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
  }

  :global(.registration .intl-tel-input .country-list) {
    width: 100%;
    top: 100%;
  }

  .no-border-bottom {
    border-bottom: none !important;
  }
  :global(.filepond--drop-label) {
    background-color: bisque !important;
    font-size: 0.8rem !important;
  }
  .main-container {
    display: flex;
    justify-content: center;
  }

  .p-row {
    display: flex;
    position: relative;
    align-items: center;
  }

  .messages {
    display: flex;
    justify-content: flex-start;
  }

  .active {
    color: #D1193E;
    background-color: #3c3c3c;
    transition: 0.4s;
  }

  .active::after {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    right: -20px;
    top: 0px;
    border-left: 20px solid rgb(37, 36, 36);
  }

  .form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    transition: 0.3s;
  }
  .form input {
    outline: none;
    border: none;
    border-bottom: 1px solid #b3b1b140;
    background: transparent;
    background-clip: content-box;
  }

  .column-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .column-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .forms-container {
    background-color: #f5f1ea;
    overflow: hidden;
    z-index: 2;
  }

  .header{
    border: 1px solid black;
  }

  .form-group {
    display: block;
  }

  .form-group input {
    padding: 0;
    height: initial;
    width: initial;
    margin-bottom: 0;
    display: none;
    cursor: pointer;
  }

  .form-group label {
    position: relative;
    cursor: pointer;
  }

  .form-group label:before {
    content: '';
    -webkit-appearance: none;
    background-color: transparent;
    border: 2px solid #D1193E;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    padding: 10px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 5px;
  }

  .form-group input:checked + label:after {
    content: '';
    display: block;
    position: absolute;
    top: 2px;
    left: 9px;
    width: 6px;
    height: 14px;
    border: solid #D1193E;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  .navigation {
    display: flex;
    justify-content: center;
    padding: 5px;
    z-index: 2;
  }
</style>

